// src/App.js
import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProductList from './pages/ProductList';
import Cart from './pages/Cart';
import Order from './pages/Order';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/Admin';
import MyOrders from './pages/MyOrders';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import ShippingPayment from './pages/ShippingPayment';

// Layout principal avec Navbar et Outlet
const MainLayout = () => (
  <div className="min-h-screen bg-slate-50 text-slate-800">
    <Navbar />
    <main className="max-w-7xl mx-auto p-6 md:p-8">
      <Outlet />
    </main>
  </div>
);

// Définition des routes avec le MainLayout
const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '',
        element: <ProductList />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'register',
        element: <Register />,
      },
      {
        path: 'shippig_payment',
        element: <ProtectedRoute><ShippingPayment /></ProtectedRoute>,
      },
      {
        path: 'cart',
        element: <Cart />,
      },
      {
        path: 'order',
        element: <ProtectedRoute><Order /></ProtectedRoute>,
      },
      {
        path: 'my-orders',
        element: <ProtectedRoute><MyOrders /></ProtectedRoute>,
      },
      {
        path: 'admin',
        element: <AdminRoute><Admin /></AdminRoute>,
      },
    ],
  },
]);

const App = () => <RouterProvider router={router} />;

export default App;
